/**
 * Foundations palette styles for the date range input and modal.
 */
const style = (theme) => {
    const { colors, typography } = theme['foundations-library']
    const accent = ({ color }) => colors[color][600]
    const tint = ({ color }) => colors[color][50]
    return {
        input: { '& input': { cursor: 'pointer' } },
        paper: {
            ...typography.body2,
            color: colors.neutral[900],
            background: '#fff',
            borderRadius: 16,
            width: 1040,
            maxWidth: 'calc(100% - 32px)',
            margin: 16
        },
        layout: { display: 'flex', padding: 28 },
        presets: {
            width: 180,
            flexShrink: 0,
            paddingRight: 24,
            marginRight: 24,
            borderRight: `1px solid ${colors.neutral[100]}`
        },
        preset: {
            ...typography.body2,
            display: 'block',
            width: '100%',
            textAlign: 'left',
            background: 'transparent',
            color: colors.neutral[900],
            border: 0,
            borderBottom: `1px solid ${colors.neutral[100]}`,
            padding: '18px 12px',
            cursor: 'pointer',
            '&[aria-pressed="true"]': { color: accent, fontWeight: 600, background: tint },
            '&:hover:not(:disabled)': { background: tint },
            '&:disabled': { color: colors.neutral[300], cursor: 'default' },
            '&:focus-visible': { outline: '2px solid', outlineColor: accent, outlineOffset: -2 }
        },
        main: { flex: 1, minWidth: 0 },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 16,
            paddingBottom: 24,
            borderBottom: `1px solid ${colors.neutral[100]}`,
            marginBottom: 24,
            '& button:focus-visible': { outline: '2px solid', outlineColor: accent, outlineOffset: 2 }
        },
        summary: {
            border: `1px solid ${colors.neutral[200]}`,
            borderRadius: 8,
            padding: '12px 16px',
            flex: '1 1 280px',
            textAlign: 'center'
        },
        actions: { display: 'flex', gap: 16, marginLeft: 'auto' },
        calendars: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 32 },
        calendar: { minWidth: 0 },
        heading: { margin: '0 0 16px', fontSize: 'inherit', fontWeight: 600 },
        selectors: {
            display: 'flex',
            gap: 8,
            marginBottom: 16,
            '& > .foundations-common-input': {
                minWidth: 0,
                flex: 1,
                '&:first-child': { flex: 2 }
            },
            '& .select-menu': {
                minWidth: 0,
                width: 'calc(100% + 24px)'
            }
        },
        grid: { display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', rowGap: 4 },
        weekday: { textAlign: 'center', padding: '10px 0', fontWeight: 600 },
        day: {
            ...typography.body2,
            border: 0,
            background: 'transparent',
            color: colors.neutral[900],
            height: 40,
            padding: 0,
            cursor: 'pointer',
            '&[data-in-range="true"]': { background: tint },
            '&[aria-pressed="true"]': { background: accent, color: '#fff', borderRadius: 6 },
            '&:hover:not(:disabled)': { boxShadow: `inset 0 0 0 1px ${colors.neutral[400]}` },
            '&:focus-visible': { outline: '2px solid', outlineColor: accent, outlineOffset: -2 },
            '&:disabled': { color: colors.neutral[300], cursor: 'default' }
        },
        '@media (max-width: 760px)': {
            layout: { flexDirection: 'column', padding: 20 },
            presets: {
                width: 'auto',
                display: 'flex',
                flexWrap: 'wrap',
                borderRight: 0,
                paddingRight: 0,
                marginRight: 0,
                marginBottom: 20,
                gap: 4
            },
            preset: { width: 'auto', padding: '8px 12px', border: 0, borderRadius: 6 },
            calendars: { gap: 20 }
        },
        '@media (max-width: 480px)': {
            calendars: { gridTemplateColumns: '1fr' },
            toolbar: { gap: 12 },
            summary: { flexBasis: '100%', padding: '10px 8px' }
        }
    }
}

export default style
